import { render, staticRenderFns } from "./modellingLeft.vue?vue&type=template&id=7133890e&scoped=true"
import script from "./modellingLeft.vue?vue&type=script&lang=js"
export * from "./modellingLeft.vue?vue&type=script&lang=js"
import style0 from "./modellingLeft.vue?vue&type=style&index=0&id=7133890e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7133890e",
  null
  
)

export default component.exports